import { Alert, Box, Flex, Text } from "@chakra-ui/react";
import { useEffect } from "react";

type Props = { values: [string, unknown][]; open?: boolean };
export const Debug: React.FC<Props> = ({ values, open }) => {
  return (
    <Flex as="pre" direction="column" overflow="auto" border="5px solid red">
      {values.map(([title, json]) => {
        return (
          <Box as="details" key={title} open={open}>
            <Text as="summary" fontWeight="bold">
              {title}:
            </Text>
            {JSON.stringify(json, replacer, 2)}
          </Box>
        );
      })}
    </Flex>
  );
};

type DebugErrorProps = {
  message?: string;
  error?: Error;
  variant?: "alert" | "inline";
};
export const DebugError: React.FC<DebugErrorProps> = ({
  message,
  error,
  variant = "alert",
}) => {
  useEffect(() => {
    console.error("DebugError: Oops! Something went wrong!", error);
  }, [error]);
  const errorMessage = message ? message : "Oops! Something went wrong!";
  switch (variant) {
    case "inline":
      return (
        <Flex
          as="pre"
          direction="column"
          overflow="auto"
          border="5px solid red"
        >
          <Box as="span" color="red" padding={1}>
            {errorMessage}
          </Box>
          {JSON.stringify(error, null, 2)}
        </Flex>
      );
    case "alert":
      return (
        <Alert status="error">
          {errorMessage} : {JSON.stringify(error, null, 2)}
        </Alert>
      );
  }
};

function replacer(key: any, value: any) {
  if (value instanceof File) {
    return {
      dataType: "File",
      name: value.name,
      size: `${value.size} bytes`,
    };
  }
  if (value instanceof Map) {
    return {
      dataType: "Map",
      value: Array.from(value.entries()),
    };
  } else if (value instanceof Set) {
    return {
      dataType: "Set",
      value: Array.from(value.values()),
    };
  } else {
    return value;
  }
}
